import NewPasswordSuccess from "./new-password-success.container";

export default NewPasswordSuccess;